import SpriteSymbol from "../../../../mobile/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-ellipses",
  "use": "svg-icon-ellipses-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-ellipses\"><switch><g><circle cx=\"12\" cy=\"2.8\" r=\"2.8\" /><circle cx=\"12\" cy=\"12\" r=\"2.8\" /><circle cx=\"12\" cy=\"21.2\" r=\"2.8\" /></g></switch></symbol>"
});
var result = sprite.add(symbol);
export default symbol